import * as React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { css } from "@emotion/react";
import f from "@/module/Utils/emotion";

interface ModalProps {
  isShow: boolean;
}

const Modal: React.FC<ModalProps> = (props) => {
  const basicModalStyle = css({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 9999,
    backgroundColor: "rgba(187, 50, 32, 0.8)",
  });
  return (
    <AnimatePresence initial={false} exitBeforeEnter={true}>
      {props.isShow && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          css={basicModalStyle}
        >
          {props.children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Modal;
